import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the QuickTaskServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class QuickTaskServiceProvider {

  dataTask:any = [];
  limitCache:number = 5;
  activeTask:any = [];

  constructor(public http: HttpClient) {
    console.log('Hello QuickTaskServiceProvider Provider');
  }

  checkDataTask(empId):Promise<any>{
    return new Promise((resolve, reject)=>{
      if(this.dataTask.length > 0){
        this.dataTask.forEach((element, index) => {
          if(element.to.empId == empId){
            resolve(element);
          } else {
            if(index == this.dataTask.length - 1){
              reject('id gak sama');
            }
          }
        });
      } else{
        reject('datanya gak ada');
      }
    })
  }

  setDataTask(item){
    this.dataTask.push(item);
    if(this.dataTask.length > this.limitCache){
      this.dataTask.shift();
    }
    console.log(this.dataTask, ' datanye')
  }

  setActiveTask(item){
    this.activeTask = item;
  }

  deleteDataTask(item){
    this.dataTask.forEach((element, index) => {
      if(element.to.empId == item.to.empId){
        this.dataTask.splice(index, 1);
        console.log(this.dataTask);
      }
    });
    this.activeTask = [];
  }

  updateDataTask(item){
    if(item.task){
      this.dataTask.forEach(element => {
        if(element.to.empId == item.to.empId){
          element = item;
        }
      });
    } else{
      this.dataTask.pop();
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/quick-task-service/quick-task-service.ts